import templateStr from 'text!./templates/ho-edit-scheduled-property.html';
import EntityUtil from 'gw-portals-util-js/EntityUtil';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            model: '=gwQnbHoEditScheduledProperty',
            onListChange: '=',
            loading: '=?'
        },
        controller: ['$scope', function (scope) {
            function notifyChange() {
                if (scope.onListChange) {
                    scope.onListChange();
                }
            }

            scope.addScheduledProperty = function () {
                /* Do this on push as "null" would be set when custom quote is loaded without
                 * any additional properties.
                 */
                if (!scope.model.value) {
                    scope.model.value = [];
                }
                scope.model.value.push({
                    tempID: EntityUtil.nextId(),
                    type: 'Jewelry'
                });
                notifyChange();
            };

            scope.removeScheduledProperty = function (index) {
                scope.model.value.splice(index, 1);
                notifyChange();
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/ho/directives/HOEditScheduledProperty.js
// module id = 1457
// module chunks = 0